module.exports = __webpack_public_path__ + "img/reference38.33eb7999.jpg";